import { Accordion, Button, Flex } from '@chakra-ui/react'
import { useFieldArray } from 'react-hook-form'
import { ItemPerguntasResposta } from './ItemPerguntasResposta'

export const ListaPerguntasRespostas = ({ onDelete }) => {
  const { fields, append, remove } = useFieldArray({
    name: 'perguntas_respostas',
  })

  return (
    <Flex flexDir="column" gap={2}>
      <Accordion allowToggle>
        {fields.map((field, index) => (
          <ItemPerguntasResposta onDelete={onDelete} key={field.id} field={field} remove={remove} index={index} />
        ))}
      </Accordion>
      <Button colorScheme="green" size="sm" alignSelf="flex-end" justifySelf="flex-end" onClick={() => append({ pergunta: '', resposta: '' })}>
        Adicionar
      </Button>
    </Flex>
  )
}
